<template>
    <svg width="20" height="17" viewBox="0 0 20 17" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(-319 -22.5)">
            <rect width="20" height="3" rx="1.5" transform="translate(319 29.5)" />
            <rect width="20" height="3" rx="1.5" transform="translate(319 22.5)" />
            <rect width="20" height="3" rx="1.5" transform="translate(319 36.5)" />
        </g>
    </svg>
</template>
